import * as React from "react";
const SvgFiRrPokerChip = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-poker-chip_svg__a)">
      <path
        fill="#062147"
        d="M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m10 12a10 10 0 0 1-.186 1.9l-1.932-.58a7.4 7.4 0 0 0 0-2.64l1.932-.58A10 10 0 0 1 22 12m-.76-3.816-1.93.579a8.05 8.05 0 0 0-4.073-4.073l.579-1.93a10.06 10.06 0 0 1 5.424 5.424M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12m1.9-15.814-.58 1.932a7.4 7.4 0 0 0-2.64 0l-.58-1.932a9.8 9.8 0 0 1 3.8 0m-5.716.574.579 1.93A8.05 8.05 0 0 0 4.69 8.763l-1.93-.579A10.06 10.06 0 0 1 8.184 2.76M2 12a10 10 0 0 1 .186-1.9l1.932.58a7.4 7.4 0 0 0 0 2.64l-1.932.58A10 10 0 0 1 2 12m.76 3.816 1.93-.579a8.05 8.05 0 0 0 4.073 4.073l-.579 1.93a10.06 10.06 0 0 1-5.424-5.424m7.34 6 .58-1.932a7.4 7.4 0 0 0 2.64 0l.58 1.932a9.8 9.8 0 0 1-3.8 0m5.716-.575-.579-1.929a8.05 8.05 0 0 0 4.073-4.073l1.93.579a10.05 10.05 0 0 1-5.424 5.421zm-1.185-10.349a1.85 1.85 0 0 1 0 2.216l-1.893 2.523a.922.922 0 0 1-1.476 0l-1.893-2.523a1.85 1.85 0 0 1 0-2.216l1.893-2.523a.922.922 0 0 1 1.476 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-poker-chip_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPokerChip;
